import { cloneElement, Children } from 'react';
import { html } from '@fp/html'
import PropTypes from 'fe-prop-types'

const genTitleId = () => (Date.now() + ~~(Math.random() * 999999)).toString(36);

const isReactElement = element => element.$$typeof && element.$$typeof === Symbol.for('react.element');
export const fixKeys = (element) => {
  if (Array.isArray(element)) {
    return element.filter(Boolean).map((el, idx) => 
      isReactElement(el) 
        ? fixKeys(cloneElement(el, { key: el.key || el.props.key || idx })) 
        : el
    );
  }
  if (element && isReactElement(element)) {
    return cloneElement(element, { 
      // Children.toArray will prefix each key in the returned array for scoping.
      // In this case, empty keys will be prefixed with the index in their children array
      // See: https://reactjs.org/docs/react-api.html#reactchildrentoarray
      children: Children
        .toArray(element.props.children)
        .map((child) => {
          if (isReactElement(child)) {
            return fixKeys(child);
          }
          return child;
        })
    })
  }
  return element;
}

// eslint-disable-next-line no-unused-vars
const Icon = ({ size, title, glyph, highlight, $theme, ...props }) => {
  let titleId = null
  if (title != null) titleId = genTitleId()

  return html`
    <svg
      width=${size}
      height=${size}
      viewBox='0 0 20 20'
      aria-labelledby=${title ? titleId : null}
      ...${props}
    >
      ${title && html`<title id=${titleId}>${title}<//>`}
      ${fixKeys(glyph({ html, highlight }))}
    <//>
  `
}

Icon.propTypes = {
  glyph: PropTypes.func.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  viewBox: PropTypes.string,
  highlight: PropTypes.string,
  title: PropTypes.string,
}

Icon.defaultProps = {
  fill: '#2f3638',
  size: 16,
  highlight: '',
}

export default Icon
